export const mediaQueryMode = {
  /**
   * The media query is used when pointing device does not allow accurate pointing
   * TODO It should be change to @media (hover: none) when there will be better solution
   */
  touchDevices: '@media not (pointer: fine), (hover: none)',
};
